import {store} from 'store';

export function set({ key, module, value }, event) {
  store.dispatch({
    type: 'UI_SETTING',
    module,
    key,
    value,
  });
  event && event.stopPropagation();
}
